import React, { useEffect, useState } from 'react'
import { hasText } from 'utils/helpers'

import api from '../api'

export const QuestionContext = React.createContext()

function QuestionContextProvider({ children }) {
  const [, setError] = React.useState(null)
  const [questionContext, setQuestionContext] = useState({
    question: '',
    rid: '',
    value: '',
  })
  const [currentQuestions, setCurrentQuestions] = useState([
    {
      question: '',
      rid: '',
      value: '',
    },
  ])

  const [userAnswers, setUserAnswers] = useState([])
  const [matrixAnswers, setMatrixAnswers] = useState([])

  useEffect(() => {
    onFieldChange()
    setCurrentQuestions(currentQuestions.concat(questionContext))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionContext])

  const onFieldChange = async () => {
    if (!hasText(questionContext?.rid)) return
    try {
      await api.saveAnswer(
        questionContext.rid,
        questionContext.question,
        questionContext.value ? questionContext.value : updatedItems.toString()
      )
    } catch (error) {
      setError(error)
    }
  }

  const [checkedItems, setCheckedItems] = useState({})
  const [checkedMatrix, setCheckedMatrix] = useState({})
  const [updatedItems, setUpdatedItems] = useState([])

  const defaultContext = {
    setQuestionContext,
    questionContext,
    userAnswers,
    setUserAnswers,
    currentQuestions,
    setCurrentQuestions,
    checkedItems,
    setCheckedItems,
    updatedItems,
    setUpdatedItems,
    matrixAnswers,
    setMatrixAnswers,
    checkedMatrix,
    setCheckedMatrix,
  }

  return (
    <QuestionContext.Provider value={defaultContext}>
      {children}
    </QuestionContext.Provider>
  )
}

export default QuestionContextProvider
